module.exports = __webpack_public_path__ + "img/momo_index_logo.10587a77.png";